<template>
  <section
    class="content"
    v-permission.if="[USER_ROLES.ADMIN,USER_ROLES.SUPER_ADMIN,USER_ROLES.GA_HEAD,USER_ROLES.JOURNEY_MANAGER,USER_ROLES.REPORT_STAFF,USER_ROLES.SALES_MANAGER]"
  >
    <div>
      <div class="box-body">
        <div
          :class="addButtonClass"
          v-permission.if="[USER_ROLES.ADMIN,USER_ROLES.SUPER_ADMIN,USER_ROLES.GA_HEAD,USER_ROLES.REPORT_STAFF]"
        >
          <router-link :to="{ name: 'ReportScheduleCreate' }">
            <button class="btn">Schedule New</button>
          </router-link>
        </div>
        <v-server-table
          ref="schedulereportTable"
          url
          :columns="columns"
          :options="options"
          v-on:row-click="edit"
          @loaded="onLoaded"
        >
          <template slot="beforeBody">
            <tr v-if="loading" class="VueTables__no-results">
              <td class="text-center" colspan="6">
                <pulse-loader></pulse-loader>
              </td>
            </tr>
          </template>
        </v-server-table>
      </div>
    </div>
  </section>
</template>

<script>
import { USER_ROLES } from '../../../config';
import { Event } from 'vue-tables-2';
import moment from 'moment';
import {mapState} from 'vuex';
export default {
name: 'ReportSchedule',
    data() {
        return {
            USER_ROLES: USER_ROLES,
            loading: null,
            schedulereportTable: null,
            columns: [
                'reportType',
                'reportFrequency',
                'vehicleNo',
                'scheduleStartDate',
                'scheduleEndDate',
                'status',
            ],
            options: {
                highlightMatches: true,
                sortable: [
                'reportType',
                'reportFrequency',
                'vehicleNo',
                'scheduleStartDate',
                'scheduleEndDate',
                'status',
                ],
                headings: {
                    reportType: 'Report Type',
                    reportFrequency: 'Schedule Type',
                    vehicleNo  : 'Vehicle No',
                    scheduleStartDate: 'Schedule Start Date',
                    scheduleEndDate: 'Schedule End Date',
                    status: 'Status',
                },
                templates: {
                  vehicleNo(row, query) {
                    if(query.vehicleIdRegNo){
                      return query.vehicleIdRegNo
                    }
                  },
                  reportType(row,query){
                      if (query.reportType == 'hcv_ms'){
                        return "Data HCV Mother Station"
                      }
                      else if (query.reportType == 'hcv_dbs'){
                        return "Data HCV Daughter Station"
                      }
                      else if (query.reportType == 'logbook'){
                        return "Vehicle Log Book"
                      }
                      else if (query.reportType == 'dsr'){
                        return "Data Sales Report"
                      }
                    },
                    scheduleStartDate(row, query) {
                        return moment(query.scheduleStartDate).format('DD-MM-YYYY');
                    },
                    scheduleEndDate(row, query) {
                        return moment(query.scheduleEndDate).format('DD-MM-YYYY');
                    },
                    status(row, query) {
                      return query.status[0].toUpperCase() + query.status.slice(1);
                    },
                    reportFrequency(row, query) {
                      return query.reportFrequency[0].toUpperCase() + query.reportFrequency.slice(1);
                    },     
                },

                requestFunction: request => {
                    const params = {};
                    params.$page = request.page;
                    params.$limit = request.limit;
                    if(this.user.roleName == "GA Head"){
                      params.regionRegionManager = this.user._id
                    }
                    if (request.orderBy) {
                      params.$sort = request.ascending
                        ? '-' + request.orderBy
                        : request.orderBy;
                    }
                    if (request.query) {
                      params.$term = request.query;
                    }
                    if (request.query.status) {
                      params.status = request.query.status;
                    }
                    this.loading = true;
                    return this.$schedulereportDataRepository
                      .list(params)
                      .catch(error => {
                        console.error('Report.requestFunction-error:', error);
                        this.$snotify.error(
                          'Get Report Schedule History failed',
                          'Error!',
                        );
                      });
                },
                responseAdapter: response => {
                    this.loading = false;
                    console.log("response",response)
                    console.log("end date ",response.data.docs.scheduleEndDate)
                    let endDate = new Date(response.data.docs.scheduleEndDate)
                    return {
                        data: response.data.docs,
                        count: response.data.items.total,
                    };
                },
                uniqueKey: '_id',  
            }
        }
    },
    computed: {
        addButtonClass() {
            if (this.schedulereportTable) {
                return this.schedulereportTable.count > this.schedulereportTable.limit ||
                this.schedulereportTable.limit > 10
                ? 'shift-add-left'
                : 'add-item';
            } else {
                return 'add-item';
            }
        },
        ...mapState({
          user: state => state.auth.user
        }),
    },
    methods: {
      edit(data) {
      this.$router.push({
        name: 'ReportScheduleDetails',
        params: { _id: data.row._id },
        props: data.row,
      });
    },
      onLoaded() {
          this.schedulereportTable = this.$refs.schedulereportTable;
      },
      download(){
            
      }
    }
}

</script>

<style scoped>

.box-body {
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)
}
.btn{
  background-image: linear-gradient(to right, rgba(38, 153, 251), rgba(146, 205, 255));
  color: white
}
</style>


// WEBPACK FOOTER //
// ReportSchedule.vue?47baa6f8